import { render, staticRenderFns } from "./ExpiringDeals.vue?vue&type=template&id=fa33f1ee&"
import script from "./ExpiringDeals.vue?vue&type=script&lang=js&"
export * from "./ExpiringDeals.vue?vue&type=script&lang=js&"
import style0 from "./ExpiringDeals.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports